<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="3"></left-panel>
    </div>
    <div class="post-login-2-col-2 p-0 h-100 overflow-y-hidden">
        <img src="~/../assets/images/left-banner.jpg" style="height: 100%; min-width: 100%;" alt="">
    </div>
    <div class="post-login-2-col-3">
        <div class="onboarding-canvas">
            <grid-row class="justify-content-center">
                <grid-col col="6" class="h-500">
                    <grid-row class="justify-content-center align-content-between mt-30 h-100">
                        <grid-col col="12">
                            <grid-row>
                                <grid-col col="8">
                                    <div class="font-400 font-size-20px line-h-25">
                                        {{ "UploadequiredDocuments" | translate }}
                                    </div>
                                </grid-col>
                            </grid-row>
                        </grid-col>
                        <grid-col col="12">
                            <attach-box heading="Signature" text="SimplySignPlainWhitePaper" imageName="MySignature.jpg"></attach-box>
                        </grid-col>
                        <grid-col col="12">
                        <button class="btn-dft" (click)="loanReviewSuccess()">
                            {{ "NEXT" | translate }}
                        </button>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>

<!-- <modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="CONTINUE"
    [hideHeader]="false">
    <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1 text-uppercase">
        {{"PaymentBreakdown" | translate}}
    </div>
    <grid-row class="justify-content-between align-item-center mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800 letter-spacing-2">
                {{"LoanAmount" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                {{"BHD" | translate}} 4,000.00
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between align-item-center mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800 letter-spacing-2">
                {{"InterestAmount" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                {{"BHD" | translate}} 4,121.840
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between align-item-center mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800 letter-spacing-2">
                {{"Interestrate" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                3.88%
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between align-item-center mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800 letter-spacing-2">
                {{"NoInstallments" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                {{"BHD" | translate}} 4,000.00
            </div>
        </grid-col>
    </grid-row>
    <grid-row class="justify-content-between align-item-center mt-24">
        <grid-col col="auto">
            <div class="font-400 font-size-12px line-h-20 color-base-1800 letter-spacing-2">
                {{"LatePaymentCharges" | translate}}
            </div>
        </grid-col>
        <grid-col col="auto">
            <div class="font-600 font-size-14px line-h-20 color-base-1300 letter-spacing-2">
                1%
            </div>
        </grid-col>
    </grid-row>
    <div class="text-align-center mt-30">
        <div class="font-400 font-size-12px line-h-20 color-base-1200 letter-spacing-1">
            {{"YouRestartPayment" | translate}}
        </div>
        <div class="font-600 font-size-24px line-h-24 color-base-1300 letter-spacing-1 mt-5">
            16th January 2023
        </div>
    </div>
</modal> -->